<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<ng-container *ngIf="!isLoading; else loading">
  <div class="recCnt">
    <div class="sample">
      <span class="gender-title">Sex: {{ sex ?? '-' }}</span>
      <span class="variCnt">Variants: {{ variantsCount | number }}</span>
      <span class="geneCnt">Gene: {{ geneCount | number }}</span>
    </div>
  </div>

  <div class="table-wrap" *ngIf="!isLoading">
    <div class="h-wrap">
      <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true">

        <!-- svId -->
        <ng-container matColumnDef="svId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="svId">SV_ID</th>
          <td mat-cell *matCellDef="let r">{{ r.svId }}</td>
        </ng-container>

        <!-- chrId -->
        <ng-container matColumnDef="chrId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="chrId">Chr</th>
          <td mat-cell *matCellDef="let r">{{ getChrLabel(r.chrId) }}</td>
        </ng-container>

        <!-- start -->
        <ng-container matColumnDef="start">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="start">Start Position</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="r.start != null;">
              <a href="javascript:void(0)" (click)="openUCSC(r.chrId, r.start)" class="position">
                {{ r.start * 1000 | number }}
              </a>
            </ng-container>
          </td>
        </ng-container>

        <!-- end -->
        <ng-container matColumnDef="end">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="end">End Position</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="r.end != null;">
              <a href="javascript:void(0)" (click)="openUCSC(r.chrId, r.end)" class="position">
                {{ r.end * 1000 | number }}
              </a>
            </ng-container>
          </td>
        </ng-container>

        <!-- length -->
        <ng-container matColumnDef="length">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="length">Length</th>
          <td mat-cell *matCellDef="let r">{{ r.length == null ? '' : (r.length * 1000 | number) }}</td>
        </ng-container>

        <!-- chrToId -->
        <ng-container matColumnDef="chrToId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="chrToId">Chr(To)</th>
          <td mat-cell *matCellDef="let r">{{ getChrLabel(r.chrToId) }}</td>
        </ng-container>

        <!-- startTo -->
        <ng-container matColumnDef="startTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="startTo">Start(To)</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="r.startTo != null && r.chrToId != null;">
              <a href="javascript:void(0)" (click)="openUCSC(r.chrToId, r.startTo)" class="position">
                {{ r.startTo * 1000 | number }}
              </a>
            </ng-container>
          </td>
        </ng-container>

        <!-- endTo -->
        <ng-container matColumnDef="endTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="endTo">End(To)</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="r.endTo != null && r.chrToId != null;">
              <a href="javascript:void(0)" (click)="openUCSC(r.chrToId, r.endTo)" class="position">
                {{ r.endTo * 1000 | number }}
              </a>
            </ng-container>
          </td>
        </ng-container>

        <!-- lengthTo -->
        <ng-container matColumnDef="lengthTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="lengthTo">Length(To)</th>
          <td mat-cell *matCellDef="let r">{{ r.lengthTo == null ? '' : (r.lengthTo * 1000 | number) }}</td>
        </ng-container>

        <!-- type -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="type">SV Type</th>
          <td mat-cell *matCellDef="let r">{{ r.type }}</td>
        </ng-container>

        <!-- zygosity -->
        <ng-container matColumnDef="zygosity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="zygosity">Zygosity</th>
          <td mat-cell *matCellDef="let r">{{ r.zygosity }}</td>
        </ng-container>

        <!-- flaggedSv -->
        <ng-container matColumnDef="flaggedSv">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="flaggedSv">Flagged SV</th>
          <td mat-cell *matCellDef="let r">{{ r.flaggedSv ==="Y" ? 'Embedded' : '' }}</td>
        </ng-container>

        <!-- genename -->
        <ng-container matColumnDef="genename">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="genename">Gene Name</th>
          <td mat-cell *matCellDef="let r" class="genes">
            <div class="gene-container" *ngIf="r.geneLinks?.length;">
              <ng-container *ngFor="let g of (r.geneLinks.slice(0, 10));">
                <a href="javascript:void(0)" (click)="openEnsembl(g.id)" class="gene-name">
                  {{ g.name }}
                </a>
              </ng-container>
              <button *ngIf="r.geneLinks.length > 10" mat-button color="primary" class="link-like"
                (click)="openGenesDialog(r.svId, r.geneLinks)">
                +{{ r.geneLinks.length - 10 }}
              </button>
            </div>
          </td>
        </ng-container>

        <!-- genenameTo -->
        <ng-container matColumnDef="genenameTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="genenameTo">Gene Name(To)</th>
          <td mat-cell *matCellDef="let r" class="genes">
            <div class="gene-container" *ngIf="r.geneLinksTo?.length;">
              <ng-container *ngFor="let g of (r.geneLinksTo.slice(0, 10));">
                <a href="javascript:void(0)" (click)="openEnsembl(g.id)" class="gene-name">
                  {{ g.name }}
                </a>
              </ng-container>
              <button *ngIf="r.geneLinksTo.length > 10" mat-button color="primary" class="link-like"
                (click)="openGenesDialog(r.svId, r.geneLinksTo)">
                +{{ r.geneLinksTo.length - 10 }}
              </button>
            </div>
          </td>
        </ng-container>

        <!-- withAnnotation -->
        <ng-container matColumnDef="withAnnotation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="withAnnotation">With Annotation</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="isAnnotated(r.svId);">
              <span class="with-annotation" [withAnnotTooltip]="buildTooltip(r.svId)"
                withAnnotTooltipPosition="right">◯</span>
            </ng-container>
          </td>
        </ng-container>

        <!-- minimumIntervalDepth -->
        <ng-container matColumnDef="minimumIntervalDepth">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="minimumIntervalDepth">Minimum Interval Depth</th>
          <td mat-cell *matCellDef="let r">{{ r.minimumIntervalDepth == null ? '-' : (r.minimumIntervalDepth | number:'1.1-1') }}</td>
        </ng-container>

        <!-- medianIntervalDepth -->
        <ng-container matColumnDef="medianIntervalDepth">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="medianIntervalDepth">Median Interval Depth</th>
          <td mat-cell *matCellDef="let r">{{ r.medianIntervalDepth == null ? '-' : (r.medianIntervalDepth | number:'1.1-1') }}</td>
        </ng-container>

        <!-- qualityScore -->
        <ng-container matColumnDef="qualityScore">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="qualityScore">Quality Score</th>
          <td mat-cell *matCellDef="let r">{{ r.qualityScore | qualityMax4 }}</td>
        </ng-container>

        <!-- reason -->
        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="reason">Reason</th>
          <td mat-cell *matCellDef="let r">{{ r.reason }}</td>
        </ng-container>

        <!-- molCheck -->
        <ng-container matColumnDef="molCheck">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="molCheck">SV Breakpoint Molecule Check</th>
          <td mat-cell *matCellDef="let r">{{ r.molCheck == null ? '-' : (r.molCheck ? 'pass' : 'fail') }}</td>
        </ng-container>

        <!-- colorSdb -->
        <ng-container matColumnDef="colorSdb">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="colorSdb">CoLoR SdB Control DB Frequency (%)</th>
          <td mat-cell *matCellDef="let r">{{ r.colorSdb == null ? '-' : (r.colorSdb | number:'1.2-2') }}</td>
        </ng-container>

        <!-- gnomAd -->
        <ng-container matColumnDef="gnomAd">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="gnomAd">gnomAD Control DB Frequency (%)</th>
          <td mat-cell *matCellDef="let r">{{ r.gnomAd == null ? '-' : (r.gnomAd | number:'1.2-2') }}</td>
        </ng-container>

        <!-- ontLrs -->
        <ng-container matColumnDef="ontLrs">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="ontLrs">ONT LRS Control DB Frequency (%)</th>
          <td mat-cell *matCellDef="let r">{{ r.ontLrs == null ? '-' : (r.ontLrs | number:'1.2-2') }}</td>
        </ng-container>

        <!-- masked -->
        <ng-container matColumnDef="masked">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="masked">Masked</th>
          <td mat-cell *matCellDef="let r">{{ r.masked == null ? '-' : (r.masked ? 'true' : 'false') }}</td>
        </ng-container>

        <!-- bestSvPerCluster -->
        <ng-container matColumnDef="bestSvPerCluster">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="bestSvPerCluster">Best SV per Cluster</th>
          <td mat-cell *matCellDef="let r">{{ r.bestSvPerCluster == null ? '-' : (r.bestSvPerCluster ? 'true' : 'false') }}</td>
        </ng-container>

        <!-- actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let r">
            <app-icons icon="search_insights" ariaLabel="Open Alignment Viewer" [isDisabled]="false"
              (iconClickEvent)="openAlignmentView(r)">
            </app-icons>
          </td>
        </ng-container>

        <!-- header & rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr class="mat-mdc-row no-data-row" *matNoDataRow>
          <td class="mat-mdc-cell no-data-cell" [attr.colspan]="displayedColumns.length">
            No Data Found
          </td>
        </tr>

      </table>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="loader" aria-live="polite" aria-busy="true">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>